import { useState } from "react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { User, LogOut } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { useNavigate } from "react-router-dom";

export default function UserMenu() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  if (!user) return null;
  const initial = (user.name || user.email || "?").trim()[0].toUpperCase();

  const handleLogout = async () => {
    setOpen(false);
    await logout();
    nav("/login", { replace: true });
  };

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="user-menu-button"
          className="w-9 h-9 rounded-full bg-[#FCE7F3] dark:bg-[#2E2140] border border-[#F5D0E3] dark:border-[#45325A] text-[#C9286F] dark:text-[#C4A1FF] font-semibold text-sm grid place-items-center hover:bg-[#F5D0E3] transition-colors overflow-hidden"
          aria-label="Account menu"
        >
          {user.picture ? (
            <img src={user.picture} alt="" className="w-full h-full object-cover" />
          ) : (
            initial
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56 bg-white dark:bg-[#3B2350]">
        <DropdownMenuLabel className="text-xs font-normal">
          <div className="text-[#7A6A8C] uppercase tracking-wide text-xs">Signed in as</div>
          <div className="text-sm font-medium text-[#3B2350] dark:text-[#FBEFF6] truncate mt-0.5">
            {user.name || user.email.split("@")[0]}
          </div>
          <div className="text-xs text-[#7A6A8C] truncate">{user.email}</div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          data-testid="logout-button"
          onClick={handleLogout}
          className="text-[#C9286F] dark:text-[#C4A1FF] focus:text-[#C9286F] focus:bg-[#FCE4F0] dark:focus:bg-[#4A1D3A] cursor-pointer"
        >
          <LogOut className="w-4 h-4 mr-2" />
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
